<template>
  <div>
    <Table :no-data-text="$t('common.noData')" :columns="columns" :data="accountGroupConfigData" style="width: 100.1%;" :loading="accountGroupConfigLoading" :height="550">
      <!-- 删除 -->
      <template slot-scope="{row,index}" slot="delete">
        <span @click="doDelete(index)">
            <Button type="error" size="small" @click="accountGroupConfigDelmodal = true" v-hasPermission="['permissionsConfigurationManagement:accountGroupConfig:delete']">{{ $t('common.del') }}</Button>
        </span>
      </template>
    </Table>
    <!-- 删除组模式框 -->
    <Modal v-model="accountGroupConfigDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t('alarms.common.sureDelete') }} {{accountGroupConfigName}} ?</p>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long :loading="modal_loading" @click="removeAccountConfigGroup()" :disabled="isDisable">
          {{ $t('common.del') }}
        </Button>
      </div>
    </Modal>
  </div>
</template>
<script>

    var tableAccountGroupConfigVue = {};
    export default {
        name: 'TableAccountGroupConfig',
        data() {
            return {
                areaTypeList:[this.$t('RIAccountGroupManagement.China'),this.$t('RIAccountGroupManagement.Overseas')],
                val: '',
                accountGroupConfigLoading: false,
                accountGroupConfigDelmodal: false,
                accountGroupConfigName: '',
                modal_loading: false,
                isDisable: false,
                columns: [
                    {
                        title: this.$t('RIAccountGroupManagement.accountName'),
                        key: 'name'
                    },
                    {
                        title: this.$t('companyManagement.companyName'),
                        key: 'companyName'
                    },
                    {
                        title: this.$t('RIAccountGroupManagement.accountID'),
                        key: 'accountId'
                    },
                    {
                        title: this.$t('RIAccountGroupManagement.region'),
                        key: 'areaType'
                    },
                    {
                        title: this.$t('RIAccountGroupManagement.AvailabilityZone'),
                        key: 'region'
                    },
                    {
                        title: this.$t('common.operation'),
                        slot: 'delete'
                    }
                ],
                accountGroupConfigData: []
            }
        },
        beforeCreate: function () {
            tableAccountGroupConfigVue = this
        },
        mounted: function () {
            tableAccountGroupConfigVue.selectAccountGroupConfigData();
        },
        methods: {
            showAll: function () {
                tableAccountGroupConfigVue.selectAccountGroupConfigData();
            },
            doDelete: function (index) {
                this.lineIndex = index;
                this.accountGroupConfigName = this.accountGroupConfigData[index].name;
            },
            // 查询数据
            selectAccountGroupConfigData: function () {
                this.accountGroupConfigLoading=true;
                this.$api.accountGroup.selectAccountGroup('id', this.$route.query.id)
                .then(res => {
                    this.accountGroupConfigData = res.data.accountList;
                    // 地区
                    for(var i=0;i<this.accountGroupConfigData.length;i++){
                        if (this.accountGroupConfigData[i].areaType === 1){
                          this.accountGroupConfigData[i].areaType = this.$t('RIAccountGroupManagement.China');
                        } else {
                          this.accountGroupConfigData[i].areaType = this.$t('RIAccountGroupManagement.Overseas');
                        }
                    }
                    this.accountGroupConfigLoading=false;
                })
            },
            // 删除
            removeAccountConfigGroup: function () {
                this.isDisable = true;  //开始可以点击
                var lineIndex = this.lineIndex;
                //账户删除
                this.$api.account.deleteByAccountGroup({
                    "id":this.$route.query.id,
                    "accountId":this.accountGroupConfigData[lineIndex].id,
                })
                    .then(res => {
                        this.modal_loading = true;
                        setTimeout(() => {
                            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                            //21条  3页  2*10+1时删除
                            if (lineIndex == 0 && ((this.current - 1) * this.pageSize + 1) == this.dataTotal) {
                                this.current = this.current - 1;
                            }
                            this.dataTotal = this.dataTotal - 1;
                            tableAccountGroupConfigVue.selectAccountGroupConfigData();
                            this.isDisable = false;
                            this.modal_loading = false;
                            this.accountGroupConfigDelmodal = false;
                            this.$Message.success(this.$t('common.deleteSuccess'));
                        }, 1000);
                    })
            }
        }
    }
</script>
<style scoped>
  .ivu-page {
    margin-top: 10px !important;
    margin-bottom: 30px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/account_group/TableAccountGroupConfig.vue